/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import {
    getContainerClient,
    getFilesInContainer,
    getFileInContainer,
    createFileInContainer,
    deleteFileInContainer,
    copyFileInContainer,
} from "cms/integration/azure/storage/azure-blob-storage";
import { Logger } from "cms/utils/log/logger";

// storageAccount and containerName are the archive location
export const archiveFileAzure = async (
    storageAccount,
    containerName,
    source_url,
    file_name,
    userDelegateSasToken
) => {
    const containerClient = await getContainerClient(storageAccount, containerName, userDelegateSasToken);
    await copyFileInContainer(containerClient, source_url, file_name, userDelegateSasToken);
    // await deleteFileInContainer(containerClient, file)
};

// storageAccount and containerName are the archive location
export const restoreFileAzure = async (
    storageAccount,
    containerName,
    file,
    userDelegateSasToken
) => {
    const containerClient = await getContainerClient(storageAccount, containerName, userDelegateSasToken);
    await copyFileInContainer(containerClient, file);
};

export const deleteFileAzure = async (
    storageAccount,
    containerName,
    file,
    userDelegateSasToken
) => {
    const containerClient = await getContainerClient(storageAccount, containerName, userDelegateSasToken);
    await deleteFileInContainer(containerClient, file);
};

export const uploadFileAzure = async (
    storageAccount,
    containerName,
    file,
    userDelegateSasToken
) => {
    if (!file) {
        return [];
    }
    let upload_status;
    try {
        Logger.debug(`uploading ${file.name} to ${storageAccount}/${containerName}/?${userDelegateSasToken}`);
        // console.log(`uploading ${file.name} to ${storageAccount}/${containerName}/?${userDelegateSasToken}`)
        // console.log('File , ', file)
        const containerClient = await getContainerClient(storageAccount, containerName, userDelegateSasToken);
        
        // upload file
        await createFileInContainer(containerClient, file);
        
        upload_status = {
            status: "UPLOADED",
            message: "The upload has completed successfully."
        };
    } catch (err) {
        Logger.error(err);
        upload_status = {
            status: "ERROR",
            message: err.message,
        };
        //TODO: throw on error to stop further uploads
    }
    return upload_status;
};

export const getFileFromAzure = async (
    storageAccount,
    containerName,
    file_name,
    userDelegateSasToken
) => {
    try {
        if (!file_name) {
            return;
        }
        Logger.debug(`deleting ${file_name} from ${storageAccount}/${containerName}/${file_name}?${userDelegateSasToken}`);
        const containerClient = getContainerClient(storageAccount, containerName, userDelegateSasToken);
        return await getFileInContainer(containerClient, file_name, userDelegateSasToken);
    } catch (err) {
        Logger.error(err);
    }
};

// export const getFileAzure = async (storageAccount, containerName, file_name, userDelegateSasToken) => {
//     try {
//         if (!file_name) {
//             return
//         }
//         Logger.debug(`retrieving ${file_name} to ${storageAccount}/${containerName}/?${userDelegateSasToken}`)
//
//         const containerClient = getContainerClient(storageAccount, containerName, userDelegateSasToken)
//
//         return await getFileFromStorage(storageAccount, containerName, fileName, sasToken)
//
//         // return await getImageFromStorage(containerClient, file)
//     } catch (err) {
//         Logger.error(err)
//     }
// }


export const getFiles = getFilesInContainer;

